import { Location } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import { injectTimeoutService } from '@df/ng/timeout.service';
import { CustomerLoggedGuard } from '@df/session/customer/customer-logged.guard';
import { NeedLoginService } from '@df/session/need-login.service';
import { ModalService } from '@df/ui/modal/modal.service';
import { ICmsModalService } from '@icms/client/assets/modal/icms-modal.service';

@Injectable({
    providedIn: 'root'
})
export class CustomerLoggedGuardDecorator extends CustomerLoggedGuard {
    protected modalService = inject(ModalService);
    protected cmsModalService = inject(ICmsModalService);
    protected needLoginService = inject(NeedLoginService);
    protected location = inject(Location);
    protected timeoutService = injectTimeoutService();

    override onError(): void {
        const path = this.router.url;
        const routerEventsSubscription = this.app.meta.routerEvents.subscribe(event => {
            if (event instanceof NavigationEnd) {
                routerEventsSubscription.unsubscribe();

                this.timeoutService.setTimeout(() => {
                    this.modalService.closeAll();

                    this.needLoginService.needLogin(() => {
                        // go back to original location
                        if (path !== this.router.url) {
                            this.location.back();
                        }
                    });
                }, 100);
            }
        });

        super.onError();
    }
}
